import { render, staticRenderFns } from "./ProfileRegister.vue?vue&type=template&id=2532b23a"
import script from "./ProfileRegister.vue?vue&type=script&lang=js"
export * from "./ProfileRegister.vue?vue&type=script&lang=js"
import style0 from "./ProfileRegister.vue?vue&type=style&index=0&id=2532b23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports